import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DiscountType } from '../../../models/coupons/discount-type-model';
import { Coupon } from '../../../models/coupons/coupon-model'
import { CouponsService } from '../../../services/coupons/coupons.service';
import { UtilitiesService } from '../../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { RolePermissionService } from '../../../services/role/role-permission.service';
@Component({
    selector: 'app-coupons-list',
    templateUrl: './coupons-list.component.html',
    styleUrls: ['./coupons-list.component.scss']
})
/** coupons-list component*/
export class CouponsListComponent {
  public couponsList: Coupon[];
  //Filter items from grid
  searchKeyword: string;
  discountTypeId: number;
  discountTypeList: DiscountType[];
  isActive: string;
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;

  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public showBoundaryLinks: boolean;
  public isLoaded: boolean = false;
    /** coupons-list ctor */
  constructor(private readonly couponsService: CouponsService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly discountTypeService: DiscountTypeService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {

    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.searchKeyword = "";
    this.isLoaded = false;
    this.showBoundaryLinks = true;
    this.rolePermissionService.GetRolePermissions("coupon").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.isActive = "";
          this.discountTypeId = 0;
          this.getDiscountTypes();
         this.OnFilterChange();
        // this.getcoupons();
         // this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
         
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  getDiscountTypes() {
    this.discountTypeService.getActiveDiscountTypes().subscribe(
      data => {
        this.discountTypeList = data;
      }
    )
  }
  deletecoupon(id) {
    if (confirm("Are you sure to delete this coupon ?")) {
      this.couponsService.deleteCoupon(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Coupon has been Deleted.', 'Success');
            setTimeout(() => {
              this.getcoupons();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Oop!', 'Error');
          }
        }
      )
    }
  }
  getcoupons() {
    this.couponsService.getCoupons().subscribe(
      data => {
        this.couponsList = data 
        this.filteredItems = data;
      }
    )
  }

  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid


  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  OnFilterChangegrid() {
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.couponsService.getCouponsGrid(this.pagenumber, this.rowsOnPage, this.searchKeyword, this.isActive, this.discountTypeId).subscribe(
      data => {
        this.isLoaded = true;
        this.couponsList = data;
        if (this.couponsList != null && this.couponsList.length > 0)
          this.totalRecord = this.couponsList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }


}



// WEBPACK FOOTER //
// ./src/app/coupons/coupons/coupons-list/coupons-list.component.ts